import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { printPDFSaga } from 'b2b-apps/shop/common/redux/pdf/saga';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import {
  wishlistPrintFulfilled,
  wishlistPrintRejected,
} from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/actionCreators';
import { WISHLIST_PRINT } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/actionTypes';
import { WishlistPrintAction } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/types';

function* printWishlistSaga(
  action: WishlistPrintAction,
): Generator<CallEffect | PutEffect, any, AxiosResponse> {
  const { content, fileName } = action.payload;

  try {
    yield call(printPDFSaga, content, fileName);
    yield put(wishlistPrintFulfilled());
  } catch (error) {
    yield put(reportError(action.type, error, action.payload));
    yield put(wishlistPrintRejected(parseError(error)));
  }
}

function* wishlistPrintSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all(
    [
      takeEvery(WISHLIST_PRINT, printWishlistSaga),
    ],
  );
}

export {
  wishlistPrintSaga,
};
